import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'Uploaded' },
    { value: 2, label: 'Acknowledged' },
    { value: 3, label: 'Confirmed' },
    { value: 4, label: 'Failed' },
  ],
});
